<template>
  <v-app style="overflow-y: hidden" :dark="userSettings.useDarkMode">
    <router-view></router-view>
  </v-app>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { setDefaultOptions } from "esri-loader";

export default {
  name: "App",

  computed: {
    ...mapState([
      "sidebarHasOpened",
      "showSideMenu",
      "bottomTabsHeight",
      "userSettings",
      "mapLoaded",
      "tabsAreOpen",
      "showImageGallery",
    ]),
    showTabs: {
      set(showTabs) {
        this.setShowTabs(showTabs);
      },
      get() {
        return this.$store.state.showTabs;
      },
    },
    mapHeight: {
      set(mapHeight) {
        this.setMapHeight(mapHeight);
      },
      get() {
        return this.$store.state.mapHeight;
      },
    },
  },
  data() {
    return {
      mapSplitPaneMinSize: 300,
      bottomTabsSplitPaneMinSize: 48,
    };
  },
  mounted() {
    this.getAndSetProfiles();
  },
  watch: {
    "userSettings.theme": function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setThemeColor(newVal);
      }
    },
    "userSettings.useDarkMode": function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$vuetify.theme.secondary = newVal ? "#585858" : "#f5f5f5";
      }
    },
  },
  created() {
    setDefaultOptions({
      version: "4.20",
      css: true,
      dojoConfig: {
        locale: "nb",
      },
    });

    this.setThemeColor(this.userSettings.theme);
  },
  methods: {
    ...mapActions(["getAndSetProfiles", "setShowTabs", "setMapHeight"]),
    onDragEnd(size) {
      this.setMapHeight(size[0]);
      this.setBottomTabsHeight(size[1]);
    },
    setThemeColor(theme) {
      this.$vuetify.theme = JSON.parse(JSON.stringify(theme.definition));
      this.$vuetify.theme.secondary = this.userSettings.useDarkMode
        ? "#585858"
        : "#f5f5f5";
    },
  },
};
</script>
<style>
html {
  overflow-y: hidden;
}

.content-container {
  padding: 0px;
}

.content-container-mobile {
  position: fixed; /* fix to avoid scroll in chrome address bar */
}

.drawer-button {
  margin-bottom: 10px;
  margin-top: 10px;
}

.drawer-icon {
  font-size: 22px !important;
}

.drawer-content {
  margin-left: 56px;
}

.drawer-icon-active {
  padding-left: 5px;
  margin-left: 14px;
  margin-right: 14px;
  margin-top: -15px;
  margin-bottom: 12px;
  border-bottom: 3px solid deepskyblue;
}

div.hideGutter div.gutter.gutter-vertical {
  display: none !important;
}

.the-split-panel {
  height: 100%;
}

.right-navigation-drawer {
  z-index: 9;
  background: #eceff1;
}

.map-container {
  position: relative;
  height: 100%;
}

::-webkit-scrollbar-track {
  /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); */
  border-radius: 0px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  border-radius: 0px;
  /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3); */
  background-color: gray;
}
</style>
